"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jwt_decode_1 = tslib_1.__importDefault(require("jwt-decode"));
const RefreshTokenException_1 = tslib_1.__importDefault(require("../models/Exceptions/RefreshTokenException"));
const InvalidTokenException_1 = tslib_1.__importDefault(require("../models/Exceptions/InvalidTokenException"));
const refreshToken_graphql_1 = tslib_1.__importDefault(require("../gql/users/mutations/refreshToken.graphql"));
const User_1 = tslib_1.__importDefault(require("../models/User"));
class JWT {
    static storageGet(item) {
        return localStorage.getItem(item) || null;
    }
    static storageSet(item, value) {
        localStorage.setItem(item, value);
    }
    static storageRemove(item) {
        localStorage.removeItem(item);
    }
    static apiRegenerate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const refreshToken = JWT.storageGet(JWT.refreshTokenName);
            let accessToken;
            let newRefreshToken;
            if (!refreshToken) {
                JWT.clear();
                throw new RefreshTokenException_1.default(new Error('No refresh token available.'));
            }
            try {
                ({
                    accessToken,
                    refreshToken: newRefreshToken,
                } = (yield new User_1.default().fetchToken(refreshToken_graphql_1.default, { refreshToken })));
                JWT.storageSet(JWT.tokenName, accessToken);
                JWT.storageSet(JWT.refreshTokenName, newRefreshToken);
            }
            catch (e) {
                throw new RefreshTokenException_1.default(e);
            }
            return accessToken;
        });
    }
    static getToken() {
        return JWT.storageGet(JWT.tokenName);
    }
    static isExpired() {
        const expiryDate = JWT.getExpiryDate();
        return !expiryDate || (new Date()).getTime() >= expiryDate.getTime();
    }
    static getExpiryDate() {
        const encodedToken = JWT.getToken();
        if (!encodedToken) {
            return null;
        }
        const token = jwt_decode_1.default(encodedToken);
        if (!token || !token.exp)
            return new Date('2000-01-01');
        return new Date(+token.exp * 1000);
    }
    static regenerate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield JWT.apiRegenerate();
            JWT.verify();
        });
    }
    static verify() {
        const token = JWT.getToken();
        if (!token || JWT.isExpired()) {
            throw new InvalidTokenException_1.default();
        }
    }
    static clear() {
        JWT.storageRemove(JWT.tokenName);
        JWT.storageRemove(JWT.refreshTokenName);
    }
    static retrieve() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.verify();
            }
            catch (validationException) {
                yield JWT.regenerate();
            }
            return JWT.getToken();
        });
    }
}
exports.default = JWT;
JWT.tokenName = 'accessToken';
JWT.refreshTokenName = 'refreshToken';
//# sourceMappingURL=jwt.js.map